/** @readonly Legacy / unmapped routes — super admin only */
export const LEGACY_ROUTES = Object.freeze({
  /** Lead forms / tables builder (campaign-scoped paths under /r/records/:campaignId/...) */
  RECORDS_BASE: '/r/records',
  RECORDS: '/r/records/v1',
  REPORTING: '/r/records/view-report',
  SUPPLIER_BASE_TYPE: '/r/supplier/base-type/list',
  SUPPLIER_TYPE: '/r/supplier/type/list',
  SUPPLIER_LIST: '/r/supplier/list',
  INVENTORY_BASE: '/r/inventory/base/list',
  INVENTORY_LIST: '/r/inventory/list',
  BOOKING_BASE: '/r/booking/base/list',
  BOOKING_TEMPLATE: '/r/booking/template/list',
  BOOKING_CAMPAIGNS: '/r/booking/campaigns',
  AI: '/r/ai',
  VECTOR: '/r/vector/add-knowledge',
  ECOMMERCE_ORDERS: '/r/e-commerce/orders',
  ECOMMERCE_LISTING: '/r/e-commerce/listing',
  ECOMMERCE_FLOW: '/r/e-commerce/flow',
  TOOLS: '/r/tools',
  MACHADALO_STUDIO: '/r/machadalostudio/companysetup',
  LICENSE_DASHBOARD: '/r/license-dashboard',
  ONBOARDING: '/r/onboarding',
  STUDENT_CONCEPT_BUILDER: '/r/student/concept-builder',
  STUDENT_CREATE_TEST: '/r/student/create-test',
  STUDENT_KNOWLEDGE_MAP: '/r/student/knowledge-map',
  STUDENT_PLATFORM: '/r/student/platform-dashboard',
  STUDENT_PERFORMANCE: '/r/student/performance-map',
  STUDENT_NOTICES: '/r/student/notices',
  STUDENT_QUESTION_BANK: '/r/student/question-bank',
  SETTINGS: '/r/settings',
});
